exports = module.exports = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main[data-v-078753dd]{width:100%;position:relative;overflow:hidden}.app-main[data-v-078753dd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.hasTagsView .app-main[data-v-078753dd]{overflow:hidden;height:calc(100vh - 110px)}.hasTagsView .app-main div[data-v-078753dd]:first-child{width:100%;height:100%;overflow:auto}", ""]);

// exports
